import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { SubscriptionSubmitFormModal } from '../Pricing/SubscriptionSubmitFormModal';

const RequestCallback = (props) => {

    const navigate = useNavigate()
    const [openModal, setOpenModal] = useState(props?.requestModalPopUp);

    const handleCloseSubmitPopup = (flag) => {
        window.$("#submitFormModal").modal("hide");
        setOpenModal('');
        if (flag) {
            navigate(`/successful-submission`, { state: { showThankYouPage: true } });
        }
    }

    useEffect(() => {
        setOpenModal(props?.requestModalPopUp);
    }, [props?.requestModalPopUp])

    return (
        <>
            {openModal && < SubscriptionSubmitFormModal handleCloseSubmitPopup={handleCloseSubmitPopup} pageType={"REQUEST_CALLBACK"} paymentDetails={{ planType: "DEVELOP", productType: "DEVELOP" }} />}
        </>
    )
}

export default RequestCallback